// 環境に応じたAPI URL設定
const getApiUrl = () => {
  // VITE_API_URLが設定されていればそれを使う（Vercel環境変数で環境ごとに切り替え）
  const envUrl = import.meta.env.VITE_API_URL;
  if (envUrl) return envUrl;

  const RAILWAY_API = import.meta.env.VITE_API_URL || 'https://registration-app-production.up.railway.app';
  const LOCALHOST_API = 'http://localhost:3000';

  if (typeof window === 'undefined') {
    return RAILWAY_API;
  }

  const isLocalhost =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';

  if (isLocalhost) {
    return LOCALHOST_API;
  }

  return RAILWAY_API;
};

// API設定の中央集約
export const API_CONFIG = {
  get BASE_URL() {
    return getApiUrl();
  },
  TIMEOUT: 10000,
  RETRY_ATTEMPTS: 3,
};

// デフォルトのAPI URL
export const API_URL = getApiUrl();
